import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import WebsiteEntity from '../components/WebsiteEntity';

class WebsiteEntityPage extends Component {
  static propTypes = {
    website: PropTypes.array.isRequired
  }

  static defaultProps = {
    website: []
  }

  render() {
    const website = this.props.website[0];
    return (
      <WebsiteEntity data={ website } />
      );
  }
}

WebsiteEntityPage = connectToStores(WebsiteEntityPage, ['WebsiteStore'], (stores, props) => {
  return {
    website: stores.WebsiteStore.get()
  };
});

export default WebsiteEntityPage;


// WEBPACK FOOTER //
// ./src/pages/WebsiteEntityPage.js